import React, { useState } from 'react';
import '../global/styles.css';

function HamburgerMenu({ isAdmin = false, onLogout, onNavigate }) {
  const [isOpen, setIsOpen] = useState(false);
  const [showEMSModal, setShowEMSModal] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleNavigate = (location) => {
    if (location === 'ems-station') {
      setIsOpen(false);
      setShowEMSModal(true);
    } else {
      onNavigate(location);
      setIsOpen(false); // Close menu after navigation
    }
  };

  const handleLogout = () => {
    onLogout();
    setIsOpen(false);
  };

  const locations = [
    { id: 'mayo-21', name: 'Mayo 21', path: '/locations/mayo21' },
    { id: 'mayo-22', name: 'Mayo 22', path: '/locations/mayo22' },
    { id: 'mayo-23', name: 'Mayo 23', path: '/locations/mayo23' },
    { id: 'mayo-24', name: 'Mayo 24', path: '/locations/mayo24' },
    { id: 'mayo-25', name: 'Mayo 25', path: '/locations/mayo25' },
    { id: 'ems-station', name: 'EMS Station', path: '/locations/ems-captain' },
    { id: 'daily-truck', name: 'Daily Truck', path: '/locations/engine41' }
  ];

  return (
    <>
      {/* Hamburger Button */}
      <button
        className={`menu-toggle ${isOpen ? 'open' : ''}`}
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        <div className="hamburger-lines">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>

      {/* Overlay */}
      {isOpen && <div className="menu-overlay" onClick={toggleMenu}></div>}

      {/* Menu Panel */}
      <div className={`menu-panel ${isOpen ? 'open' : ''}`}>
        <div className="menu-header">
          <h3 className="title-auth">Mayo Clinic</h3>
          <button className="btn-close" onClick={toggleMenu}>×</button>
        </div>

      <div className="menu-content">
  {/* Navigation Section */}
  <div className="menu-section">
    <h4 className="section-title">Navigation</h4>

    <button
      className="btn btn-secondary btn-full menu-item-compact"
      onClick={() => window.open('/status', '_blank')}
    >
      📊 Daily Status
    </button>

    <button
      className="btn btn-secondary btn-full menu-item-compact"
      onClick={() => handleNavigate('update-status')}
    >
      ✏️ Update Daily Status
    </button>

    <button
      className="btn btn-secondary btn-full menu-item-compact"
      onClick={() => handleNavigate('home')}
    >
      Home Dashboard
    </button>

    <button
      className="btn btn-secondary btn-full menu-item-compact"
      onClick={() => handleNavigate('daily-dashboard')}
    >
      Daily Dashboard
    </button>
  </div>

          {/* Locations Section */}
          <div className="menu-section">
            <h4 className="section-title">Locations</h4>
            {locations.map(location => (
              <button
                key={location.id}
                className="btn btn-secondary btn-full menu-item-compact"
                onClick={() => handleNavigate(location.id)}
              >
                {location.name}
              </button>
            ))}
          </div>

          {/* Resources Section */}
          <div className="menu-section">
            <h4 className="section-title">Resources</h4>
            <button
              className="btn btn-secondary btn-full menu-item-compact"
              onClick={() => handleNavigate('patient-care-guidelines')}
            >
              Patient Care Guidelines
            </button>
            <button
              className="btn btn-secondary btn-full menu-item-compact"
              onClick={() => handleNavigate('patient-weight-converter')}
            >
              Patient Weight Converter
            </button>
            <button
              className="btn btn-secondary btn-full menu-item-compact"
              onClick={() => handleNavigate('iv-medication-calculator')}
            >
              IV Medication Calculator
            </button>
            <button
              className="btn btn-secondary btn-full menu-item-compact"
              onClick={() => handleNavigate('glasgow-coma-scale')}
            >
              Glasgow Coma Scale
            </button>
            <button
              className="btn btn-secondary btn-full menu-item-compact"
              onClick={() => handleNavigate('apgar-calculator')}
            >
              APGAR Calculator
            </button>
            <button
              className="btn btn-secondary btn-full menu-item-compact"
              onClick={() => handleNavigate('hamilton-t1-duration')}
            >
              Hamilton T1 Cylinder Durations
            </button>
            <button
              className="btn btn-secondary btn-full menu-item-compact"
              onClick={() => handleNavigate('phone-directory')}
            >
              Phone Directory
            </button>
          </div>

          {/* Settings Section */}
          <div className="menu-section">
            <h4 className="section-title">Settings</h4>
            <button
              className="btn btn-secondary btn-full menu-item-compact"
              onClick={() => handleNavigate('profile')}
            >
              Profile
            </button>
            {isAdmin && (
              <button
                className="btn btn-secondary btn-full menu-item-compact"
                onClick={() => handleNavigate('admin-dashboard')}
              >
                Admin Dashboard
              </button>
            )}
            <button
              className="btn btn-primary btn-full menu-item-logout"
              onClick={handleLogout}
            >
              Log Out
            </button>
          </div>
        </div>
      </div>

      {/* EMS Station Options Modal */}
      {showEMSModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10000
        }}>
          <div style={{
            background: 'white',
            borderRadius: '15px',
            padding: '40px',
            maxWidth: '500px',
            width: '90%',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '30px'
            }}>
              <h2 style={{ color: '#333', fontSize: '24px', margin: 0 }}>
                EMS Station Options
              </h2>
              <button
                onClick={() => setShowEMSModal(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '28px',
                  cursor: 'pointer',
                  color: '#666'
                }}
              >
                ×
              </button>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              <button
                className="btn btn-primary btn-full"
                onClick={() => {
                  setShowEMSModal(false);
                  onNavigate('ems-station');
                }}
                style={{
                  padding: '20px',
                  fontSize: '18px',
                  background: '#000',
                  borderColor: '#000'
                }}
              >
                Update Station Inventory
              </button>

              <button
                className="btn btn-primary btn-full"
                onClick={() => {
                  setShowEMSModal(false);
                  onNavigate('ems-expired');
                }}
                style={{
                  padding: '20px',
                  fontSize: '18px',
                  background: '#0E3293',
                  borderColor: '#0E3293'
                }}
              >
                Update Expired Medications
              </button>

              <button
                className="btn btn-primary btn-full"
                onClick={() => {
                  setShowEMSModal(false);
                  onNavigate('non-controlled');
                }}
                style={{
                  padding: '20px',
                  fontSize: '18px',
                  background: '#2e7d32',
                  borderColor: '#2e7d32'
                }}
              >
                Non-Controlled Medications
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default HamburgerMenu;
